import { render, staticRenderFns } from "./BoLegal.vue?vue&type=template&id=1a5730e8&"
import script from "./BoLegal.vue?vue&type=script&lang=js&"
export * from "./BoLegal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports